export const ARTICLES = [
  {
    slug: "how-credit-scores-work",
    title: "How Credit Scores Work",
    description:
      "An introduction to what credit scores are, who calculates them and the general categories of factors that may influence them.",
  },
  {
    slug: "understanding-credit-utilization",
    title: "Understanding Credit Utilization",
    description:
      "What utilization means, how it is generally calculated and why it is often discussed as an important part of a credit profile.",
  },
  {
    slug: "personal-credit-vs-business-credit",
    title: "Personal Credit vs Business Credit",
    description:
      "How personal and business credit differ, how they can interact and why both may matter for entrepreneurs.",
  },
  {
    slug: "what-does-funding-ready-mean",
    title: "What Does Funding Ready Mean?",
    description:
      "A plain-language look at the preparation and organization that may help before pursuing financing opportunities.",
  },
  {
    slug: "hard-vs-soft-credit-inquiries",
    title: "Hard vs Soft Credit Inquiries",
    description:
      "The difference between hard and soft inquiries and when each type typically occurs.",
  },
  {
    slug: "why-payment-history-matters",
    title: "Why Payment History Matters",
    description:
      "Why payment history is widely considered a foundational part of a credit profile and how habits may affect it.",
  },
  {
    slug: "what-lenders-may-evaluate",
    title: "What Lenders May Evaluate",
    description:
      "Common categories lenders may review — creditworthiness, documentation, cash flow and other eligibility standards.",
  },
  {
    slug: "business-credit-fundamentals",
    title: "Business Credit Fundamentals",
    description:
      "An overview of how business credit works and how businesses can begin building stronger financial foundations.",
  },
  {
    slug: "building-better-financial-habits",
    title: "Building Better Financial Habits",
    description:
      "Practical, responsible habits around payments, organization and borrowing that may support long-term financial health.",
  },
  {
    slug: "preparing-your-business-for-financing",
    title: "Preparing Your Business for Financing",
    description:
      "Steps business owners can consider — organization, documentation and readiness — before submitting financing applications.",
  },
];
